module.exports = __webpack_public_path__ + "img/arrow-collapse-vertical.cac6d974.svg";